import { Reveal } from "@/lib/motion";
import { PRICING } from "@/data/content";
import { Check, ArrowRight } from "lucide-react";

export default function Pricing({ onBook }) {
  return (
    <section className="relative z-10 py-20 md:py-28 bg-slate-50 border-y border-slate-100">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <Reveal className="text-center">
          <span className="overline">Pricing</span>
          <h2 className="font-heading text-3xl md:text-5xl font-bold text-slate-900 tracking-tight mt-3 max-w-3xl mx-auto">
            Indicative starting prices. Every project scoped to your goals.
          </h2>
        </Reveal>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-5 mt-14">
          {PRICING.map((p, i) => (
            <Reveal key={p.name} delay={(i % 4) * 0.06}>
              <div
                className={`h-full p-7 rounded-2xl border flex flex-col hover-lift ${p.highlight ? "border-brand bg-white soft-shadow-lg ring-1 ring-brand/20" : "border-slate-200 bg-white card-shadow"}`}
                data-testid={`pricing-${i}`}
              >
                {p.highlight && <span className="self-start text-[10px] font-bold uppercase tracking-wide bg-blue-100 text-brand px-2.5 py-1 rounded-full mb-3">Most Popular</span>}
                <h3 className="font-heading text-lg font-bold text-slate-900">{p.name}</h3>
                <div className="mt-3 flex items-baseline gap-1.5">
                  <span className="text-slate-400 text-xs font-semibold uppercase">{p.note}</span>
                  <span className="font-heading text-3xl font-extrabold text-slate-900">{p.price}</span>
                </div>
                <ul className="mt-6 space-y-2.5 flex-1">
                  {p.features.map((f) => (
                    <li key={f} className="flex gap-2 text-sm text-slate-600">
                      <Check size={15} className="text-green-600 mt-0.5 shrink-0" /> {f}
                    </li>
                  ))}
                </ul>
                <button onClick={onBook} className={`mt-6 w-full py-3 rounded-xl flex items-center justify-center gap-2 ${p.highlight ? "btn-primary" : "btn-outline"}`}>
                  Get Started <ArrowRight size={15} />
                </button>
              </div>
            </Reveal>
          ))}
        </div>
        <Reveal className="text-center">
          <p className="text-slate-400 text-sm mt-8">
            + WebsiteTech Care, Growth & Intelligence — monthly subscriptions for maintenance, SEO, analytics, AI & automation.
          </p>
        </Reveal>
      </div>
    </section>
  );
}
